import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import {
  ARCHIVED_CAREER_RESTORE,
  RECOVER_CAREERS_PATH
} from '../../features/pricing/archived-careers'

// Aktion im Hinweis zur archivierten Stelle (D16). Führt zu den gelöschten
// Stellen, dort wird die Stelle wiederhergestellt. onNavigate schließt vorher
// den Dialog, in dem der Hinweis steht. Gestaltet wie die Aktionen im
// Nutzungsbanner, passend zum Ton warning von InfoCallout.
const ArchivedCareerRestoreAction = ({ onNavigate }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <button
      type='button'
      onClick={() => {
        onNavigate()
        navigate(RECOVER_CAREERS_PATH)
      }}
      className='inline-flex items-center whitespace-nowrap rounded font-semibold text-yellow-800 underline-offset-2 hover:text-yellow-900 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-700'
    >
      {t(ARCHIVED_CAREER_RESTORE)}
    </button>
  )
}

ArchivedCareerRestoreAction.propTypes = {
  onNavigate: PropTypes.func
}

ArchivedCareerRestoreAction.defaultProps = {
  onNavigate: () => undefined
}

export default ArchivedCareerRestoreAction
